import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getAllControllHistory(condition = {}) {
  let response = {}
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/ControlHistory/status/ControlHistory`)

  } catch (err) {
    console.error('iisi getAllControllHistory: ', err)
    return null
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function getAllTimeControllHistory(controlData = {}) {
  let response = {}
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/ControlHistory`)
    
  } catch (err) {
    console.error('iisi getAllControllHistory: ', err)
    return null
  }

  Utils.setApiResponsSuccess(response)
  return response
}


export async function postControllHistory(controlData = {}) {
  if(Utils.isEmptyObject(controlData) || Utils.isEmptyObject(controlData.scenicAreaId) || 
    Utils.isEmptyObject(controlData.controlHistoryType) || Utils.isEmptyObject(controlData.controlswitch)) {

      console.error('iisi postControllHistory: controlData is null')
      return null
  }

  let response = {}
  controlData.changeTime = moment().format().split('+')[0] //2022-08-05T14:41:00+08:00 移除時區(+之後)

  try {
    response = await axios.post(`${config.eastCoastDataApi()}BaseData/ControlHistory`, controlData)

  } catch (err) {
      console.error('iisi postControllHistory: ', err)
      return null
  }

  Utils.setApiResponsSuccess(response)
  return response
}
export async function getControlHistoryByTimeInterval(condition = {}) {
  //debugger
  let response = {}
  if (Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('iisi getStayAverageData: time is null')
    return response
  }
  let startTime = encodeURIComponent(moment(condition.startTime).format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `?sttime=${startTime}` : ''
  let endTime = encodeURIComponent(moment(condition.endTime).format().split('+')[0])
  let endTimeQuery = startTime ? `&endtime=${endTime}` : ''
  // let scenicAreaIdQuery = Utils.isEmptyObject(condition.scenicAreaId) ? '' : `&scenicAreaIds=${condition.scenicAreaId}`
  let scenicAreaIdQuery = "";
  if(condition.scenicAreaId === null) {
    scenicAreaIdQuery = "";
  }else{

    if(condition.scenicAreaId.length > 1) {
      const query = condition.scenicAreaId.map((scenicAreaId) => `scenicAreaIds=${scenicAreaId}`).join('&');
      scenicAreaIdQuery =  "&"+query;

    }else{
      scenicAreaIdQuery = `&scenicAreaIds=${condition.scenicAreaId}`
    }
  }
  
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/ControlHistory/ControlHistoryByTimeInterval${startTimeQuery}${endTimeQuery}${scenicAreaIdQuery}`)
    //debugger
  } catch (err) {
    console.error('iisi getAllControllHistory: ', err)
    //debugger
    return null
  }

  Utils.setApiResponsSuccess(response)
  return response
}